// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.44.2/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".base-layout {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100vh;\n  overflow: auto;\n}\n.base-layout.un-scrollable {\n  overflow: hidden;\n}\n.base-layout .base-layout-content {\n  flex: 1 1 auto;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n  .base-layout .base-layout-content + .footer.not-fixed {\n    /* IE10+ CSS styles */\n    margin-top: 56px;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
